import { __awaiter, __generator } from "tslib";
import { w } from '@tinkoff/statist-page-data';
export var compress = function (json) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, Promise.resolve()
                .then(function () {
                var stream = new Blob([json], { type: 'application/json' }).stream();
                var compressedStream = stream.pipeThrough(new w.CompressionStream('gzip'));
                return compressedStream;
            })
                .then(function (compressedStream) { return new Response(compressedStream); })
                .then(function (compressedResponse) { return compressedResponse.blob(); })];
    });
}); };
//# sourceMappingURL=gzip.js.map